<template>
  <span
    class="status-wrapper"
    data-testid="status-wrapper"
  >
    <el-loading
      v-if="statusesIcons[status] && statusesIcons[status].name === 'spinner'"
      class="spinner"
      size="16"
    />
    <el-icon
      v-else-if="statusesIcons && statusesIcons[status] && statusesIcons[status].name"
      class="status"
      :data-testid="statusesIcons[status].name"
      :name="statusesIcons[status].name"
      size="16"
      :style="{ color: iconColor }"
    ></el-icon>
    <span
      v-else
      class="status round"
      data-testid="round"
      :style="{ 'background-color': iconColor }"
    ></span>
    <span
      v-if="$slots.default"
      class="status-text"
    >
      <slot></slot>
    </span>
  </span>
</template>

<script>
  import { ref, computed } from 'vue';
  import { STATUSES_ICONS_MAPPING } from '@/common/utils/statuses';

  export default {
    name: 'Status',
    props: {
      status: String,
      color: String
    },
    setup(props) {
      const statusesIcons = ref(STATUSES_ICONS_MAPPING);

      const iconColor = computed(() => props.color || (props.status && statusesIcons.value[props.status]?.color));

      return {
        iconColor,
        statusesIcons
      };
    }
  };
</script>

<style lang="scss" scoped>
  .status-wrapper {
    display: inline-flex;
    align-items: center;
    margin-right: 8px;
    max-width: 100%;
  }

  .status-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    align-self: baseline;
    margin-left: 8px;
  }

  .spinner {
    flex-shrink: 0;
  }

  .status {
    flex-shrink: 0;
  }

  .round {
    display: inline-block;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    margin: 0 4px;
    min-width: 8px;
  }
</style>
